export const routes = [

  {
    path: '/',
    name: 'Mentored',
    component: () => import('./pages/index.vue'),
    meta: {
      title: 'Наставления',
      authorize: [],
    },
    children: [
      {
        path: 'search',
        name: 'SearchMentor',
        component: () => import('./pages/MentorSearch.vue'),
        meta: {
          title: 'Поиск наставника',
          breadcrumbs: {
            parent: 'Mentored',
          },
        },
      },
      {
        path: 'recommendation-programs',
        name: 'RecommendationPrograms',
        component: () => import('./pages/RecomindationPrograms.vue'),
        meta: {
          title: 'Рекомендации',
          breadcrumbs: {
            parent: 'Mentored',
          },
        },
      },
      {
        path: 'recommendation-practice',
        name: 'RecommendationPractice',
        component: () => import('./pages/RecomindationPractice.vue'),
        meta: {
          title: 'Рекомендации',
          breadcrumbs: {
            parent: 'Mentored',
          },
        },
      },
    ],
  },
  {
    path: '/questionnaire-form/:id',
    name: 'QuestionnaireForm',
    component: () => import('./pages/QuestionnaireForm.vue'),
    meta: {
      title: 'Заполнение анкеты',
      breadcrumbs: {
        parent: 'Mentored',
      },
    },
  },
];

export default routes;
